import { ApolloClient, InMemoryCache } from '@apollo/client';
import config from 'src/config';

const cache = new InMemoryCache({
  typePolicies: {
    Query: {
      fields: {
        health: {
          merge(incoming, existing = {}) {
            return { ...existing, ...incoming };
          },
        },
      },
    },
  },
});

const apolloClient = new ApolloClient({
  uri: [config.REACT_APP_API_URL, 'graphql'].join('/'),
  cache
});

export default apolloClient;
